import axios from "axios";

export const GET_CONTRACT_URL = id => `/companies/${id}/contract`;
export const UPLOAD_SIGNED_CONTRACT_URL = id => `/companies/${id}/upload-signed-contract`;

const corporateService = {
  getContract: (id) => axios.get(GET_CONTRACT_URL(id)),
  uploadSignedContract: (id, formData) => axios.post(UPLOAD_SIGNED_CONTRACT_URL(id), formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export default corporateService
